import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "element", "icon"]

  connect() {
    this.linkTarget.addEventListener("click", this.toggle.bind(this))
  }

  toggle() {
    if ($(this.elementTarget).is(":visible")) {
      $(this.elementTarget).slideUp(300)
      $(this.iconTarget).removeClass("fa-angle-up").addClass("fa-angle-down")
    } else {
      $(this.elementTarget).slideDown(300)
      $(this.iconTarget).removeClass("fa-angle-down").addClass("fa-angle-up")
    }
  }
}
